import styled from "styled-components";

export const Container = styled.div`
    display: block;
    width: 100%;
    overflow-x: auto;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    border-radius: 10px;

    thead {
        tr {
            border-bottom: 1px solid #ccc;
            th {
                padding: 5px 10px;
                font-weight: bold;
                text-align: left;
                color: #64696c;
                height: 50px;
                vertical-align: bottom;
                background-color: #f6f6f6;
            }
        }
    }

    tbody {
        tr {
            border-top: 1px solid #ccc;
            td {
                padding: 5px 10px;
                text-align: left;
                height: 50px;
                background-color: #f6f6f6;

                p {
                    color: ${props => props.theme.colors.danger};
                    font-weight: bold;
                    font-size: 9px;
                }
            }

            /* &:nth-of-type(odd) {
                background-color: #dedede;
            }

            &:last-child {
                border-bottom: 2px solid #64696c;
            } */

            &.error {
                td {
                    background: #ffabab;
                }
            }
        }
    }
`;